.header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  padding-bottom: 24px;
}

.titleWithMenu {
  display: flex;
  align-items: start;
  gap: 10px;
}

.titleWrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  min-width: 0;
}

.name {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.authorNote {
  font-size: 13px;
  color: var(--color-text-secondary);

  a {
    color: inherit;
    text-decoration-color: rgb(from var(--color-text-secondary) r g b / 50%);

    &:hover {
      text-decoration: none;
    }
  }
}

.description {
  font-size: 15px;
}

.headerButtonWrapper {
  display: flex;
  gap: 8px;
}

.iconButton {
  box-sizing: content-box;
  padding: 7px;
  border-radius: 4px;
  border: 1px solid var(--color-border-primary);

  svg {
    width: 20px;
    height: 20px;
  }
}

.sensitiveScreen {
  margin-inline: 16px;
}

.subheadingWithSelect {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  padding-inline: 16px;
}

.selectWrapper {
  // Align to right edge even when wrapped to new line
  margin-inline-start: auto;
}

.select {
  height: 36px;
  border-radius: 8px;
  font-size: 15px;
  background-color: var(--color-bg-primary);
}

.columnSubheading {
  font-size: 15px;
  font-weight: 500;
}
